import { api } from '@kolab/dms-base/api'
import type {
  CreateResellerRequest,
  PageableQuery,
  PaginatedResponse,
  Reseller,
  SetResellerStatusRequest,
  UpdateResellerRequest,
} from './types'

const BASE = '/v1/resellers'

export interface ListResellersQuery extends PageableQuery {
  distributorId?: string
}

export async function listResellers(params?: ListResellersQuery) {
  return api.get<PaginatedResponse<Reseller>>(BASE, { params, _suppressErrorToast: true }).then((r) => r.data)
}

export async function getReseller(id: string) {
  return api.get<Reseller>(`${BASE}/${id}`).then((r) => r.data)
}

export async function createReseller(payload: CreateResellerRequest) {
  return api.post<Reseller>(BASE, payload).then((r) => r.data)
}

export async function updateReseller(id: string, payload: UpdateResellerRequest) {
  return api.put<Reseller>(`${BASE}/${id}`, payload).then((r) => r.data)
}

export async function setResellerStatus(id: string, payload: SetResellerStatusRequest) {
  return api.put<Reseller>(`${BASE}/${id}/status`, payload).then((r) => r.data)
}

export async function softDeleteReseller(id: string) {
  return api.delete<Reseller>(`${BASE}/${id}`).then((r) => r.data)
}
